import { render, staticRenderFns } from "./AgendaAppuntamentiComponent.vue?vue&type=template&id=52a6e847"
import script from "./AgendaAppuntamentiComponent.vue?vue&type=script&lang=js"
export * from "./AgendaAppuntamentiComponent.vue?vue&type=script&lang=js"
import style0 from "./AgendaAppuntamentiComponent.vue?vue&type=style&index=0&id=52a6e847&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports